export const AUTH_INIT = 'AUTH_INIT'
export const AUTH_TOKEN_REQUEST = 'AUTH_TOKEN_REQUEST'
export const AUTH_TOKEN_REQUEST_SUCCESS = 'AUTH_TOKEN_REQUEST_SUCCESS'
export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST'
export const AUTH_REFRESH_REQUEST = 'AUTH_REFRESH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_LOGOUT_ERROR = 'AUTH_LOGOUT_ERROR'

export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'

export const IMMO_ERROR = 'IMMO_ERROR'
export const IMMO_LIST_REQUEST = 'IMMO_LIST_REQUEST'
export const IMMO_LIST_SUCCESS = 'IMMO_LIST_SUCCESS'
export const IMMO_LIST_PAGE = 'IMMO_LIST_PAGE'
export const IMMO_LIST_FILTER = 'IMMO_LIST_FILTER'
export const IMMO_LIST_ERROR = 'IMMO_LIST_ERROR'
export const IMMO_MAP_REQUEST = 'IMMO_MAP_REQUEST'
export const IMMO_MAP_SUCCESS = 'IMMO_MAP_SUCCESS'
export const IMMO_MAP_FILTER = 'IMMO_MAP_FILTER'
export const IMMO_MAP_ERROR = 'IMMO_MAP_ERROR'

export const CUSTOMER_REQUEST = 'CUSTOMER_REQUEST'
